import { Link } from "react-router-dom";

import useStyles from "./order-is-being-processed.styles";

import StripeIcon from "../../assets/icons/stripe-icon";
import Loading from "../loading";

const OrderIsBeingProcessed = ({
  isBeingProcessed,
}: {
  isBeingProcessed: boolean;
}) => {
  const classes = useStyles({ isBeingProcessed });

  return (
    <div className={classes.container}>
      <Loading on size="6rem" thickness="1.5" />
      <StripeIcon />
      <div className={classes.isBeingProcessed}>
        Your order is being processed.
      </div>
      <div className={classes.ifYouAreNotRedirected}>
        If you're not automatically redirected,{" "}
        <Link className={classes.redirect} to="/checkout/confirmation">
          Click Here
        </Link>
      </div>
    </div>
  );
};

export default OrderIsBeingProcessed;
